import React from 'react'
import { Route, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { AdminPanel } from './admin-panel';
import { Header } from './components/header';
import { Home } from './components/pages/Home';
import { ProductsLandingPage } from './components/pages/products/ProductsLandingPage';
import { Contacts } from './components/pages/Contacts';
import { Service } from './components/pages/Service';
import { Cart } from './components/pages/cart';
import { Footer } from './components/Footer';
import { Products } from './components/pages/products';
import { SearchingPage } from './components/pages/SearchingPage';
import { LoadingPage } from './components/pages/LoadingPage';

import { ContactForm } from './components/popups/ContactForm';
import { ConsultationForm } from './components/popups/ConsultationForm';
import { ProductPage } from './components/pages/products/product_page';

import { renderPopup } from './functions/shouldPopupRender';
import { AddNewProduct } from './admin-panel/AddNewProduct';
import { ChangeProduct } from './admin-panel/ChangeProduct';
import { CategoriesSettings } from './admin-panel/categories';
import { AdminNavigation } from './admin-panel/AdminNavigation';
import {useFirebaseConnect} from "react-redux-firebase";

export const App = () => {

    useFirebaseConnect(['main_data'])
    useFirebaseConnect(['products'])

    const isLoaded = useSelector(state => state.firebase.profile.isLoaded)
    const loggedIn = useSelector(state => state.firebase.auth.isEmpty === false)

    // Checking popup opened status
    const product_page_opened = useSelector(state => state.product_page.product_page_opened)
    const contact_form_opened = useSelector(state => state.popups.contact_form_opened)
    const consultation_form_opened = useSelector(state => state.popups.consultation_form_opened)
    const add_new_product_opened = useSelector(state => state.add_product.opened)
    const change_product_opened = useSelector(state => state.change_product.opened)
    const change_caterories_opened = useSelector(state => state.popups.change_caterories_opened)
    
    return (
        <div className='App' >
            {
                isLoaded
                    ? <>
                        <main className="main-section">
                            <Header />
                            { loggedIn ? <AdminNavigation /> : null }
                            <Switch>
                                <Route exact path='/'><Home /></Route>
                                <Route exact path='/products'><ProductsLandingPage /></Route>
                                <Route exact path='/products/*'><Products /></Route>
                                <Route path='/search'><SearchingPage /></Route>
                                <Route path='/service'><Service /></Route>
                                <Route path='/contacts'><Contacts /></Route>
                                <Route path='/cart'><Cart /></Route>
                                <Route path='/admin'><AdminPanel /></Route>
                            </Switch>
                        </main>
                        
                        { renderPopup(contact_form_opened, <ContactForm />) }
                        { renderPopup(consultation_form_opened, <ConsultationForm />) }
                        { renderPopup(product_page_opened, <ProductPage />) }
                        
                        { loggedIn 
                            ? <>
                                { renderPopup(add_new_product_opened, <AddNewProduct />) }
                                { renderPopup(change_product_opened, <ChangeProduct />) }
                                { renderPopup(change_caterories_opened, <CategoriesSettings />) }
                            </>
                            : null
                        }

                        <Footer />
                    </>
                    : <LoadingPage />
            }

        </div>
    )
}


